import { connectEventStream } from './event-stream';

export interface CostUpdatedEvent {
  type: 'cost.updated';
  at: string;
}

interface Handlers {
  onUpdated: (event: CostUpdatedEvent) => void;
  onOpen?: () => void;
  onReopen?: () => void;
  onError?: () => void;
}

/**
 * Assina o aviso de gasto novo. O evento não traz número: quem recebe rebusca o
 * período que está na tela. Devolve a função de fechar, para o `onDestroy`.
 */
export function connectCostsStream(handlers: Handlers): () => void {
  return connectEventStream({
    url: '/api/costs/stream',
    onOpen: handlers.onOpen,
    onReopen: handlers.onReopen,
    onError: handlers.onError,
    onMessage: (data) => {
      try {
        const event = JSON.parse(data) as CostUpdatedEvent;
        if (event.type === 'cost.updated') handlers.onUpdated(event);
      } catch (err) {
        console.warn('SSE de custo veio ilegível', err, data);
      }
    },
  });
}
